import { useCallback, useEffect, useState } from 'react';
import { api } from '../services/api';
import {
  disableSupportPush,
  enableSupportPush,
  getPushSubscriptionState,
  iosAddToHomeHint,
  pushSupported,
  pushUnsupportedHint,
} from '../utils/supportPush';

const SW_URL = `${import.meta.env.BASE_URL}sw.js`;

export function SupportPushControls({
  onMessage,
}: {
  onMessage?: (type: 'ok' | 'err', text: string) => void;
}) {
  const [state, setState] = useState<'loading' | Awaited<ReturnType<typeof getPushSubscriptionState>>>(
    'loading',
  );
  const [busy, setBusy] = useState(false);
  const hint = iosAddToHomeHint();

  const refresh = useCallback(async () => {
    if (!pushSupported()) {
      setState('unsupported');
      return;
    }
    setState(await getPushSubscriptionState());
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const enable = async () => {
    setBusy(true);
    const res = await enableSupportPush(
      {
        getVapidPublicKey: () => api.getPushVapidKey(),
        subscribePush: (sub) => api.subscribePush(sub),
        unsubscribePush: (endpoint) => api.unsubscribePush(endpoint),
      },
      SW_URL,
    );
    setBusy(false);
    if (res.ok) {
      onMessage?.('ok', 'Уведомления включены');
      await refresh();
    } else {
      onMessage?.('err', res.message || 'Не удалось включить');
    }
  };

  const disable = async () => {
    setBusy(true);
    await disableSupportPush({
      getVapidPublicKey: () => api.getPushVapidKey(),
      subscribePush: (sub) => api.subscribePush(sub),
      unsubscribePush: (endpoint) => api.unsubscribePush(endpoint),
    });
    setBusy(false);
    onMessage?.('ok', 'Уведомления выключены');
    await refresh();
  };

  if (state === 'loading') return null;

  if (state === 'unsupported') {
    return (
      <div className="support-push-controls">
        <p className="muted" style={{ fontSize: '0.85rem', margin: 0 }}>
          {pushUnsupportedHint()}
        </p>
      </div>
    );
  }

  return (
    <div className="support-push-controls">
      {hint && <p className="muted" style={{ fontSize: '0.8rem' }}>{hint}</p>}
      {state === 'subscribed' ? (
        <button type="button" className="btn btn-ghost" disabled={busy} onClick={() => void disable()}>
          Выключить уведомления
        </button>
      ) : state === 'denied' ? (
        <p className="muted" style={{ fontSize: '0.85rem' }}>
          Уведомления заблокированы в настройках браузера.
        </p>
      ) : (
        <button type="button" className="btn btn-soft" disabled={busy} onClick={() => void enable()}>
          Включить уведомления
        </button>
      )}
    </div>
  );
}
